import { FC, useEffect } from 'react';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { EndUserGenericForm } from 'components/Forms/UserForm/SubForms/EndUserGenericForm';
import Easy from '../../assets/easyidentity.jpg';
import EndUserHeader from 'components/Headers/EndUserHeader/EndUserHeader';
import { useStore } from 'hooks/useRootStore';
import EndUserFooter from 'components/Headers/EndUserFooter/EndUserFooter';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery } from 'react-query';

const EndUserSelfRegistration: FC = () => {
  const classes = useStyles();
  const {
    endUserSettingsFormStore: { getPortalSettings, endUserConfigSettings },
    notificationStore: { openNotification },
  } = useStore();

  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: () => openNotification('error', `Can't get data`),
  });
  useAppPreloader(portalSettingsgetReq.isLoading);
  useEffect(() => {
    document.title = 'EasyIdentity: User Account Registration';
  }, []);
  const bodyStyle = {
    backgroundImage: `url(${endUserConfigSettings?.bannerImage || Easy})`,
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
  };

  return (
    <div style={bodyStyle}>
      <div>
        <EndUserHeader />
      </div>
      <Container maxWidth='xl' className={classes.container}>
        <div className={classes.formContainer}>
          <EndUserGenericForm selfRegister type='general' />
        </div>
      </Container>
      <EndUserFooter />
    </div>
  );
};

export default EndUserSelfRegistration;
